import { CommandPaletteError } from './command-palette-error';

/**
 * Error for command execution failures (when we have a known command but execution fails).
 */
const executionMarker = 'command-palette.execution.error';
const executionSymbol = Symbol.for(executionMarker);

export class CommandPaletteExecutionError extends CommandPaletteError {
  private readonly [executionSymbol] = true;

  readonly command: { id: string; type: string };
  readonly executionType: 'action-execution' | 'keyboard-shortcut';
  readonly context?: Record<string, unknown>;

  constructor({
    command,
    executionType,
    message,
    cause,
    context,
  }: {
    command: { id: string; type: string };
    executionType: 'action-execution' | 'keyboard-shortcut';
    message: string;
    cause?: unknown;
    context?: Record<string, unknown>;
  }) {
    super({ name: 'CommandPaletteExecutionError', message, cause });
    this.command = command;
    this.executionType = executionType;
    this.context = context;
  }

  static isInstance(error: unknown): error is CommandPaletteExecutionError {
    return CommandPaletteError.hasMarker(error, executionMarker);
  }
}
